import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Libraries14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.25 2.5C0.25 1.80964 0.809644 1.25 1.5 1.25H3.5C3.67778 1.25 3.84688 1.28711 4 1.35401C4.15312 1.28711 4.32222 1.25 4.5 1.25H6.5C7.01059 1.25 7.44968 1.55613 7.64373 1.99487L9.28845 1.44663C9.94338 1.22832 10.6513 1.58227 10.8696 2.2372L13.5534 10.2885C13.7717 10.9434 13.4177 11.6513 12.7628 11.8697L10.7115 12.5534C10.0565 12.7717 9.34865 12.4178 9.13034 11.7629L7.75 7.62184V11.5C7.75 12.1904 7.19036 12.75 6.5 12.75H4.5C4.32222 12.75 4.15312 12.7129 4 12.646C3.84689 12.7129 3.67778 12.75 3.5 12.75H1.5C0.809644 12.75 0.25 12.1904 0.25 11.5V2.5ZM4.75 11.25V2.75H6.25V11.25H4.75ZM1.75 2.75H3.25V11.25H1.75V2.75ZM7.94865 3.47437L9.52562 2.94871L12.0513 10.5257L10.4743 11.0513L7.94865 3.47437Z'
      fill='currentColor'
    />
  </Svg>
);

Libraries14.displayName = 'Libraries14';
export default Libraries14;
